import { OptionSelectionCounterFragment, SliderResponseRangeFragment } from '@occc/graphql';
import { convertOptionSelectionCountersToPieChartData } from './convertOptionSelectionCountersToPieChartData';
import { convertSliderResponseRangesToBarChartData } from './convertSliderResponseRangesToBarChartData';
import { ChartType, SurveyStatisticsBarChartItem, SurveyStatisticsPieChartItem } from '../types';

type ConvertStatisticsDataToChartItemParams = {
  chartType: ChartType;
  optionSelectionCounters?: OptionSelectionCounterFragment[];
  sliderResponseRanges?: SliderResponseRangeFragment[];
};
export const convertStatisticsDataToChartItem = ({
  chartType,
  optionSelectionCounters = [],
  sliderResponseRanges = [],
}: ConvertStatisticsDataToChartItemParams):
  | SurveyStatisticsPieChartItem
  | SurveyStatisticsBarChartItem => {
  if (chartType === 'pie') {
    return {
      type: 'pie',
      items: convertOptionSelectionCountersToPieChartData(optionSelectionCounters),
    };
  }

  return {
    type: 'bar',
    items: convertSliderResponseRangesToBarChartData(sliderResponseRanges),
  };
};
